(function() {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = '.collapsible';
  
    var isTransitioning = false;
  
   function init(scope) {
    var el = scope ? scope : document;
    var firstTabOpened = false;
  
    // Open the first tab in the specified container by default
    // el.querySelectorAll('.is-product').forEach(productContainer => {
    //   var firstTab = productContainer.querySelector('.product-block.product-block--tab ' + selectors.trigger);
      
    //   if (firstTab && !firstTabOpened) {
    //     openTab(firstTab);
    //     firstTabOpened = true;
    //   }
    // });
  
    // Set up event listeners for all triggers
    el.querySelectorAll(selectors.trigger).forEach((trigger) => {
      var state = trigger.classList.contains(classes.open);
      trigger.setAttribute('aria-expanded', state);
  
      trigger.removeEventListener('click', toggle);
      trigger.addEventListener('click', toggle);
    });
  }
  
    function openTab(trigger) {
      var moduleId = trigger.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
  
      if (!container) {
        moduleId = trigger.dataset.controls;
        container = document.querySelector('[data-id="' + moduleId + '"]');
      }
  
      if (container) {
        trigger.classList.add(classes.open);
        trigger.setAttribute('aria-expanded', true);
        container.classList.add(classes.open);
        container.style.height = '100%';
      }
    }
  
    function toggle(evt) {
      if (isTransitioning) {
        return;
      }
  
      isTransitioning = true;
  
      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
  
      if (!moduleId) {
        moduleId = el.dataset.controls;
      }
  
      if (!moduleId) {
        return;
      }
  
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        isTransitioning = false;
        return;
      }
  
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
  
      if (isTab) {
        if (isOpen) {
          isTransitioning = false;
          return;
        }
  
        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="' + el.dataset.id + '"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, '0', true);
        });
      }
  
      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }
  
      setTransitionHeight(container, isOpen ? '0' : '100%', isOpen, isAutoHeight);
  
      if (parentCollapsibleEl) {
        var totalHeight = isOpen ? '0' : '100%';
        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
  
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      prepareTransition(container, function() {
        container.style.height = height;
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        setTimeout(function() {
          container.style.height = 'auto';
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
  
    function prepareTransition(element, callback) {
      element.style.transition = 'height 0.5s ease';
      requestAnimationFrame(() => {
        callback();
      });
    }
  
    window.initCollapsibles = init;
  
    document.addEventListener('DOMContentLoaded', function() {
      initCollapsibles();
    });
  })();
  